/**
 * Convert API time (24h "HH:mm" or "HH:mm:ss") to 12-hour picker parts.
 */
export function parseClassTime(value) {
  if (!value || typeof value !== 'string') {
    return { hour12: '', minute: '', period: '' };
  }

  const match = value.trim().match(/^(\d{1,2}):(\d{2})(?::\d{2})?/);
  if (!match) {
    return { hour12: '', minute: '', period: '' };
  }

  let hours24 = parseInt(match[1], 10);
  const minute = match[2];
  if (Number.isNaN(hours24) || hours24 < 0 || hours24 > 23) {
    return { hour12: '', minute: '', period: '' };
  }

  const period = hours24 >= 12 ? 'PM' : 'AM';
  let hour12 = hours24 % 12;
  if (hour12 === 0) hour12 = 12;

  return {
    hour12: String(hour12),
    minute,
    period,
  };
}

/**
 * Convert 12-hour picker parts to API time "HH:mm".
 */
export function formatClassTime(hour12, minute, period) {
  if (!hour12 || !minute || !period) return '';

  let h = parseInt(hour12, 10);
  const m = String(minute).padStart(2, '0');
  if (Number.isNaN(h) || h < 1 || h > 12) return '';

  if (period === 'AM') {
    if (h === 12) h = 0;
  } else if (period === 'PM') {
    if (h !== 12) h += 12;
  } else {
    return '';
  }

  return `${String(h).padStart(2, '0')}:${m}`;
}

export const HOUR12_OPTIONS = Array.from({ length: 12 }, (_, i) => String(i + 1));

export const MINUTE_OPTIONS = Array.from({ length: 60 }, (_, i) =>
  String(i).padStart(2, '0')
);

/** Normalize API time to HH:mm for forms and storage. */
export function normalizeClassTimeForInput(value) {
  if (value == null || value === '') return '';
  const s = String(value).trim();
  const match = s.match(/^(\d{1,2}):(\d{2})/);
  if (!match) return '';
  return `${match[1].padStart(2, '0')}:${match[2]}`;
}

/** Human-readable 12-hour label for tables (e.g. "2:30 PM"). */
export function formatClassTimeDisplay(value) {
  const normalized = normalizeClassTimeForInput(value);
  if (!normalized) return '—';
  const { hour12, minute, period } = parseClassTime(normalized);
  if (!hour12 || !minute || !period) return normalized;
  return `${hour12}:${minute} ${period}`;
}
